import React, { FC, useState } from 'react'
import StarIcon from '@material-ui/icons/Star'
import {
  Avatar,
  Typography,
  useMediaQuery,
  useTheme,
  Modal,
  Paper,
  Box
} from '@material-ui/core'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'

import { components } from '@plandi/common/src/generated'
import { useReviewItemStyles } from './review-item.styles'
import Image from 'next/image'

type Props = {
  review: components['schemas']['ReviewResourse']
}

type StarIconClasses = 'lowScore' | 'highScore' | 'mediumScore'

export const ReviewItem: FC<Props> = ({ review }) => {
  const classes = useReviewItemStyles()
  const { estimate } = review
  const [openImage, setOpenImage] = useState(false)
  const [srcImage, setSrcImage] = useState('')

  const theme = useTheme()
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const storageUrl = 'https://plandi-storage.storage.yandexcloud.net/storage/'

  const starIconColor =
    estimate < 3 ? 'lowScore' : estimate < 4 ? 'mediumScore' : 'highScore'

  const handleImagePopover = (url: string) => {
    setOpenImage(true)
    setSrcImage(url)
  }

  const handleCloseImagePopover = () => setOpenImage(false)

  return (
    <div className={classes.root}>
      <div className={classes.reviewTop}>
        <div className={classes.reviewTopLeft}>
          <Avatar
            className={classes.reviewAuthorAvatar}
            src={review.user?.avatarUrl}
          />
          <Typography className={classes.reviewAuthorName} variant="body1">
            {review.user?.name}
          </Typography>
          <div className={classes.reviewEstimate}>
            {new Array(estimate).fill(1).map((_, idx) => (
              <StarIcon
                color="inherit"
                width={22}
                key={idx}
                height={21}
                className={classes[starIconColor as StarIconClasses]}
              />
            ))}
          </div>
        </div>
        {!isMobileScreen && (
          <div className={classes.reviewTopRight}>
            <Typography
              className={classes.reviewAuthorName}
              variant="subtitle2"
              color="textSecondary"
            >
              {/* 3 дня назад */}
            </Typography>
          </div>
        )}
      </div>
      <div className={classes.reviewBody}>
        <Typography className={classes.reviewText} variant="body2">
          {review.comment}
        </Typography>
        <div className={classes.reviewImagesPreviews}>
          {review?.files &&
            review.files.map((image) => (
              <Box
                key={image.id}
                className={classes.reviewBox}
                onClick={() => handleImagePopover(storageUrl + image.filename)}
              >
                <Image
                  src={storageUrl + image.filename}
                  width={29}
                  height={29}
                  alt="Фото отзыва"
                />
              </Box>
            ))}
        </div>
      </div>
      <Modal
        open={openImage}
        onClose={handleCloseImagePopover}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper className={classes.modalImage}>
          <Box className={classes.closeBtn}>
            <CloseOutlinedIcon
              style={{ color: '#fff' }}
              onClick={handleCloseImagePopover}
            />
          </Box>
          <Box
            style={{
              background: `url("${srcImage}") center center/contain no-repeat`
            }}
            className={classes.image}
          />
        </Paper>
      </Modal>
    </div>
  )
}
